/*@ngInject*/
const ProposalListRepository = function (baseRepository, currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.getProposalList = function (submissionId, accountId) {
        var url = '/rest/Proposal/List',
            params = {
                submissionId: submissionId,
                accountId: accountId,
                registrationIdentifier: submissionId ? '/SubmissionProposals/' + submissionId : '/AccountProposals/' + accountId
            };

        currentSubmissionModel.addRegistration({url: url, params: params});

        return this.get(url, {params: params});
    };

    this.processGetResponseData = function (responseData) {
        return _.each(responseData, function (proposal) {
            return _.map(proposal.quoteSummaries, function (quoteSummary) {
                quoteSummary.summary = quoteSummary.summary.replace(/\\n/g, '<br/>');
                return quoteSummary;
            });
        });
    };
};

angular.module('gw-um-submission')
    .service('proposalListRepository', ProposalListRepository);
